var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17,
    width: 55,
    height: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 82C21.6724 82 12.0086 82 6.00433 75.9955C-4.76837e-07 69.9915 0 60.3274 0 41C0 21.6724 -4.76837e-07 12.0086 6.00433 6.00433C12.0086 -4.76837e-07 21.6724 0 41 0C60.3274 0 69.9915 -4.76837e-07 75.9955 6.00433C82 12.0086 82 21.6724 82 41C82 60.3274 82 69.9915 75.9955 75.9955C69.9915 82 60.3274 82 41 82ZM41 25.625C42.6982 25.625 44.075 27.0017 44.075 28.7V37.925H53.3C54.9982 37.925 56.375 39.3018 56.375 41C56.375 42.6982 54.9982 44.075 53.3 44.075H44.075V53.3C44.075 54.9982 42.6982 56.375 41 56.375C39.3018 56.375 37.925 54.9982 37.925 53.3V44.075H28.7C27.0017 44.075 25.625 42.6982 25.625 41C25.625 39.3018 27.0017 37.925 28.7 37.925H37.925V28.7C37.925 27.0017 39.3018 25.625 41 25.625Z",
    fill: "#5D0F11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBtn);
export default __webpack_public_path__ + "static/media/AddBtn.77ac3ce9a934dd08e563be5b5f2ef096.svg";
export { ForwardRef as ReactComponent };